<div class="ddc-table-div-container-noscroll">
  <table mat-table matSort [dataSource]="campsTableDataSource" multiTemplateDataRows (matSortChange)="_updateSortParams($event)">
    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.id"></span>
      </th>
      <td mat-cell *matCellDef="let camp" [ngClass]="getCampMarkerClass(camp)" (click)="accessCamp(camp)" >
        <span>{{camp.id}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="libelleStructure">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.structures"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (click)="accessCamp(camp)" >
        <span *ngIf="getStructureOrginisatrice(camp); let structureOrganisatrice">
          <span>{{structureOrganisatrice.code}} - {{structureOrganisatrice.libelle}} (organisatrice)</span><br/>
        </span>
        <span *ngFor="let structureParticipant of getStructuresParticipantes(camp)">
          {{structureParticipant.code}} - {{structureParticipant.libelle}}<br/>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="libelle">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.libelle"></span>
      </th>
      <td mat-cell *matCellDef="let camp"  (click)="accessCamp(camp)" >
        {{camp.libelle}}
      </td>
    </ng-container>

    <ng-container matColumnDef="dateDebut">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.datesCamp"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (click)="accessCamp(camp)" >
        {{convertToHumanDate(camp.dateDebut)}} au {{convertToHumanDate(camp.dateFin)}}
      </td>
    </ng-container>

    <ng-container matColumnDef="nbreParticipants">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.participants"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (click)="accessCamp(camp)"  >
        <span>Participant(e)s: <b>{{camp.campAdherentParticipants ? camp.campAdherentParticipants.length : 0}}</b></span>
        <span *ngIf="camp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.HUIT_DIXSEPT">
                       / Maitrise : <b>{{camp.campAdherentStaffs ? camp.campAdherentStaffs.length : 0}}</b>
                    </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="nbreDiscussionSujetsOuverts">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.nbreDiscussionSujetsOuverts"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (click)="accessCamp(camp)"  >
        {{getNombreCampDiscussionSujetsOuverts(camp)}}
      </td>
    </ng-container>

    <ng-container matColumnDef="validation">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.validation"></span>
      </th>
      <td class="ddc-icon-container" mat-cell *matCellDef="let camp" (click)="accessCamp(camp)" >
        <div class="ddc-icon-container-validation ddc-progession-synthesis-recherche-camp">

          <ng-container *ngIf="camp.typeCamp.code === TypeCampEnum.CAMP_ACCOMPAGNE || camp._isCampEnfant == true; else campAutres">
            <ng-container *ngIf="camp._isCampEnfant !== true; else emptyAutorisationCamperIcon">
              <div [ngClass]="getValidationStatus('territoire', camp)?.classLevel">
                <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.AUTORISATION_CAMPER" [icon]="TooltipIconSymbolEnum.AUTORISATION_CAMPER"></ddc-tooltip-icon>
              </div>
            </ng-container>

            <ng-template #emptyAutorisationCamperIcon>
            <span class="validation-icon">
              <ddc-tooltip-icon [iconDisabled]="true" [iconText]="TooltipIconTextEnum.AUTORISATION_CAMPER" [icon]="TooltipIconSymbolEnum.AUTORISATION_CAMPER"></ddc-tooltip-icon>
            </span>
            </ng-template>

            <ng-container *ngIf="camp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.HUIT_DIXSEPT && camp._isCampEnfant !== true; else emptyTeledeclarationIcon">
              <mat-icon [ngClass]="getValidationStatus('teledeclaration', camp)?.classLevel">
                <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.TELEDECLARATION" [icon]="TooltipIconSymbolEnum.TELEDECLARATION"></ddc-tooltip-icon>
              </mat-icon>
            </ng-container>

            <ng-template #emptyTeledeclarationIcon>
            <span class="validation-icon">
              <ddc-tooltip-icon [iconDisabled]="true" [iconText]="TooltipIconTextEnum.TELEDECLARATION" [icon]="TooltipIconSymbolEnum.TELEDECLARATION"></ddc-tooltip-icon>
            </span>
            </ng-template>
          </ng-container>

          <ng-template #campAutres>
            <ng-container>
              <div [ngClass]="getValidationStatus('territoire', camp)?.classLevel">
                <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.AUTORISATION_CAMPER" [icon]="TooltipIconSymbolEnum.AUTORISATION_CAMPER"></ddc-tooltip-icon>
              </div>
            </ng-container>

            <ng-container *ngIf="camp._isCampEnfant !== true && camp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.HUIT_DIXSEPT; else emptyTeledeclarationIcon">
              <mat-icon [ngClass]="getValidationStatus('teledeclaration', camp)?.classLevel">
                <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.TELEDECLARATION" [icon]="TooltipIconSymbolEnum.TELEDECLARATION"></ddc-tooltip-icon>
              </mat-icon>
            </ng-container>

            <ng-template #emptyTeledeclarationIcon>
            <span class="validation-icon">
              <ddc-tooltip-icon [iconDisabled]="true" [iconText]="TooltipIconTextEnum.TELEDECLARATION" [icon]="TooltipIconSymbolEnum.TELEDECLARATION"></ddc-tooltip-icon>
            </span>
            </ng-template>
          </ng-template>

          <mat-icon [ngClass]="getValidationStatus('avisAP', camp)?.classLevel">
            <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.AVIS_TERRITOIRE"
                              [icon]="TooltipIconSymbolEnum.AVIS_TERRITOIRE"></ddc-tooltip-icon>
          </mat-icon>
          <mat-icon [ngClass]="getValidationStatus('avisRG', camp)?.classLevel">
            <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.AVIS_RG"
                              [icon]="TooltipIconSymbolEnum.AVIS_RG"></ddc-tooltip-icon>
          </mat-icon>
          <ng-container
            *ngIf="isCampModulesActive(camp, [CampModuleEnum.INTERNATIONAL_8_17, CampModuleEnum.INTERNATIONAL_COMP, CampModuleEnum.ACCUEIL_ETRANGER]); else emptyInternationalIcon">
            <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.AVIS_INTERNATIONAL"
                              [imgSource]="TypeAvisEnum.INTERNATIONAL" [camp]="camp"></ddc-tooltip-icon>
          </ng-container>
          <ng-template #emptyInternationalIcon>
                        <span class="validation-icon">
                          <ddc-tooltip-icon [iconDisabled]="true" [iconText]="TooltipIconTextEnum.AVIS_INTERNATIONAL"
                                            [imgSource]="TypeAvisEnum.INTERNATIONAL" [camp]="camp"></ddc-tooltip-icon>
                        </span>
          </ng-template>
          <ng-container *ngIf="isCampModulesActive(camp, [CampModuleEnum.MARIN]); else emptyMarinIcon">
                          <span class="validation-icon">
                            <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.AVIS_MARIN"
                                              [imgSource]="TypeAvisEnum.MARIN" [camp]="camp"></ddc-tooltip-icon>
                          </span>
          </ng-container>
          <ng-template #emptyMarinIcon>
                        <span class="validation-icon">
                          <ddc-tooltip-icon [iconDisabled]="true" [iconText]="TooltipIconTextEnum.AVIS_MARIN"
                                            [imgSource]="TypeAvisEnum.MARIN" [camp]="camp"></ddc-tooltip-icon>
                        </span>
          </ng-template>
          <ng-container
            *ngIf="camp && camp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.AUDACE; else emptyVaoIcon">
            <mat-icon [ngClass]="getValidationStatus('avisVao', camp)?.classLevel">
              <ddc-tooltip-icon [iconText]="TooltipIconTextEnum.AVIS_VAO"
                                [icon]="TooltipIconSymbolEnum.AVIS_VAO"></ddc-tooltip-icon>
            </mat-icon>
          </ng-container>
          <ng-template #emptyVaoIcon>
                        <span class="validation-icon">
                          <ddc-tooltip-icon [iconDisabled]="true" [iconText]="TooltipIconTextEnum.AVIS_VAO"
                                            [icon]="TooltipIconSymbolEnum.AVIS_VAO"></ddc-tooltip-icon>
                        </span>
          </ng-template>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="equipiersSoutien">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.equipiersSoutien"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (click)="accessCamp(camp)" >
        <ng-container *ngIf="camp.campAdherentSoutiens">
          <div *ngFor="let adherentSoutien of camp.campAdherentSoutiens">
            <span *ngIf="adherentSoutien.typeSoutien === CampModuleEnum.MARIN; else typeSoutien">
              <img class="ddc-icon-beside-text material-icons" src="assets/img/ddc-icon-marin-noir.png">
            </span>
            <ng-template #typeSoutien>
              <span class="ddc-icon-beside-text material-icons">{{getDdcAdherentSoutienIcon(adherentSoutien.typeSoutien)}}</span>
            </ng-template>
            <span>{{adherentSoutien.adherent.prenom}} {{adherentSoutien.adherent.nom}}</span>
          </div>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="nbParticipant">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.participants"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (click)="accessCamp(camp)" >
        <ng-container *ngIf="camp.campAdherentParticipants">
          <div>{{camp.campAdherentParticipants.length}}</div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="nbChef">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.chefs"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (click)="accessCamp(camp)" >
        <ng-container *ngIf="camp.campAdherentStaffs">
          <div>{{camp.campAdherentStaffs.length}}</div>
        </ng-container>
      </td>
    </ng-container>

    <!--<ng-container matColumnDef="pays">
      <th mat-header-cell *matHeaderCellDef>
        <span ddcLabel labelKey="appli.accueil.rechercheProjetsCamp.resultsTable.pays"></span>
      </th>
      <td mat-cell *matCellDef="let camp" (contextmenu)="accessCamp($event, camp)">
        <ng-container *ngIf="getPaysForModuleInternational(camp); let pays; else noPays">
          <span [ngClass]="pays.paysOuvert != true ? 'ddc-pays-ferme' : ''">{{pays.libelle}}</span>
        </ng-container>
        <ng-template #noPays>
          N/A
        </ng-template>
      </td>
    </ng-container>-->

    <ng-container matColumnDef="seeMore">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let camp">
        <span (click)="toggleCampDetailsVisibility(camp)" class="material-icons">more_horizantal</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let camp">
        <button
          mat-flat-button color="warn" class="ddc-button-primary"
          (click)="_deleteRecord(camp.id)"
          [disabled]="_isSaving"
        >
          <i class="material-icons">remove_circle</i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="campDetails">
      <td mat-cell *matCellDef="let camp" [attr.colspan]="_campsDisplayedColumns.length">
        <div class="ddc-details-element" [@detailExpand]="isCampDetailsExpanded(camp) ? 'expanded' : 'collapsed'">
          <ng-container *ngIf="getCampWithDetails(camp); let campWithDetails">
            <ddc-camp-details-card
              [campWithDetails]="campWithDetails"
            ></ddc-camp-details-card>
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="_campsDisplayedColumns; sticky: true"></tr>
    <tr mat-row  ddcMouseEventManager [typeDdc]="TypeDossierEnum.CAMP" [idDdc]="row.id"
        *matRowDef="let row; columns: _campsDisplayedColumns;"
        [ngClass]="
                      row.statut == StatutCampEnum.ARCHIVE ? 'ddc-projet-archive' :
                      row.statut == StatutCampEnum.ANNULE ? 'ddc-projet-annule' : ''
                    "
        (click)="expandedElement = expandedElement === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['campDetails']" class="ddc-details-row"></tr>
  </table>
</div>

